.Badge {
  --main-color: var(--primary);
  --text-color: var(--white);

  display: inline-block;
  border-radius: var(--radius-xs);
  padding: 3px 6px;
  font-size: 0.8125rem;
  text-transform: uppercase;
  border: 1px solid var(--main-color);
  background: var(--main-color);
  color: var(--text-color);
  line-height: normal;
}

.outline {
  border: 1px solid var(--main-color);
  background: var(--white);
  color: var(--main-color);
}

.size-sm {
  border-radius: 4px;
  padding: 2px 4px;
  font-size: 0.75rem;
}

.color-primary {
  --main-color: var(--primary);
  --text-color: var(--white);
}

.color-neutral {
  --main-color: var(--neutral);
  --text-color: var(--white);
}
